module.exports = __webpack_public_path__ + "assets/8a96e995e4ac1030a3a4b42001828bad.png";